export default {
  INVESTOR_PROFILE_ON_ECONOMIC_DEPENDENTS_REPOSITORY: Symbol.for('INVESTOR_PROFILE_ON_ECONOMIC_DEPENDENTS_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_ON_ECONOMIC_DEPENDENTS_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_ON_ECONOMIC_DEPENDENTS_COMMAND'),
};
